import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AttachmentService } from "src/app/services/AttachmentService";
import { FranchisesAdminService } from "../../../services/franchises-admin.service";
import { FranchiseActionsModalComponent } from "../franchise-actions-modal/franchise-actions-modal.component";
import { FranchiseDetail } from "../../../models/franchise-detail";
import { MomentPipe } from "src/app/shared/pipes/moment.pipe";
import { MomentTransformType } from "src/app/shared/models/enums";
import {
  AttachmentTypes,
  FranchiseStatus,
  ReferenceTypes,
} from "src/app/franchise-app-global";
import { AttachmentModel } from "src/app/franchise-creation/models/models";
import { BaseComponent } from "src/app/shared/base/base-component";
import { StorageService } from "src/app/admin/services/storage.services";
import { FranchiseRaiseActionsModalComponent } from "../franchise-actions-modal/franchise-raise-actions-modal/franchise-raise-actions-modal.component";

@Component({
  selector: "app-franchise-admin-details",
  templateUrl: "./franchise-admin-details.component.html",
  styleUrls: ["./franchise-admin-details.component.scss"],
})
export class FranchiseAdminDetailsComponent
  extends BaseComponent
  implements OnInit {
  id: number;
  franchise: FranchiseDetail;
  franchiseStatus = FranchiseStatus;
  referenceTypeEnum = ReferenceTypes;
  franchiseAttachments: Array<AttachmentModel> = [];
  donorAttachments: Array<AttachmentModel> = [];
  isInternal: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private franchisesAdminService: FranchisesAdminService,
    private attachmentService: AttachmentService,
    private location: Location,
    private momentPipe: MomentPipe,
    private storageService: StorageService
  ) {
    super();
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((res) => {
      this.id = res["id"];
    });
    this.getFranchiseDetails(this.id);
    const message = this.storageService.getAlertMessageFromSessionStorage();
    if (message) {
      if (message.key === "success") {
        this.translate.get(message.value).subscribe((msg) => {
          this.showSuccessMessage(msg);
          this.storageService.removeAlertMessageInSessionStorage();
        });
      } else {
        this.translate.get(message.key).subscribe((msg) => {
          this.showErrorMessage(msg);
          this.storageService.removeAlertMessageInSessionStorage();
        });
      }
    }
    this.isInternal = this.activatedRoute.snapshot.data["isInternal"];

  }

  goBack() {
    this.location.back();
  }

  open(modalTitle: string, isRaise: boolean = false) {
    const modalRef = this.modalService.open(isRaise ? FranchiseRaiseActionsModalComponent : FranchiseActionsModalComponent, {
      windowClass: "procedures-modal",
    });

    modalRef.componentInstance.modalType = modalTitle;
    modalRef.componentInstance.franchiseNo = this.franchise.franchiseNo;
    modalRef.componentInstance.franchiseId = this.franchise.id;
    modalRef.result.then(
      (result) => {
        // console.log(result);
      },
      (reason) => { }
    );
  }
  getFranchiseDetails(id: number) {
    this.franchisesAdminService.getFranchiseById(id).subscribe((res) => {
      // console.log("details", res);
      this.franchise = res;

      this.donorAttachments = this.franchise.attachments.filter(
        (attachment) => {
          if (
            attachment.attachmentTypeId == AttachmentTypes.CrCopy ||
            attachment.attachmentTypeId == AttachmentTypes.OwnershipProof ||
            attachment.attachmentTypeId == AttachmentTypes.Passport
          ) {
            return attachment;
          } else {
            return null;
          }
        }
      );

      this.franchiseAttachments = this.franchise.attachments.filter(
        (attachment) => {
          if (
            attachment.attachmentTypeId == AttachmentTypes.DislosureDocumnet ||
            attachment.attachmentTypeId == AttachmentTypes.Contracts ||
            attachment.attachmentTypeId == AttachmentTypes.Other
          ) {
            return attachment;
          } else {
            return null;
          }
        }
      );

      // console.log("franchiseAttachments", this.franchiseAttachments);

      this.franchise.franchiseStartFormatted = this.momentPipe.transform(
        this.franchise.franchiseStartDate,
        MomentTransformType.ToHijriIsoStringFormat,
        "iD/iM/iYYYY",
        "iYYYY/iM/iD"
      );
      this.franchise.franchiseEndFormatted = this.momentPipe.transform(
        this.franchise.franchiseEndDate,
        MomentTransformType.ToHijriIsoStringFormat,
        "iD/iM/iYYYY",
        "iYYYY/iM/iD"
      );
    });
  }

  downloadAttachment(publicId: string, fileName: string) {
    this.attachmentService.DownloadAdminFile(publicId, fileName);
  }
  printFranchiseCertificate(franchiseNo: string) {
    this.franchisesAdminService.PrintFranchiseCertificate(franchiseNo);
  }
}
